export default "__VITE_ASSET__QePz5RQY__"